import { FormGroup } from '@angular/forms';
import { TypeObjetMaquette } from '@pcscol/odf-api-v1-angular';
import { AbstractForm } from './abstract-form';

export abstract class AbstractDescripteursForm extends AbstractForm {
    constructor(protected formGroup: FormGroup, protected readonly typeObjetMaquette: TypeObjetMaquette) {
        super(formGroup);
    }

    get isObjetFormation(): boolean {
        return this.formGroup.controls.typeObjetMaquette?.value === TypeObjetMaquette.ObjetFormation;
    }
    get isFormation(): boolean {
        return this.formGroup.controls.typeObjetMaquette?.value === TypeObjetMaquette.Formation;
    }
    get isGroupement(): boolean {
        return this.formGroup.controls.typeObjetMaquette?.value === TypeObjetMaquette.Groupement;
    }
}
